import type { UIViewInjectedProps } from '@uirouter/react';

import { Attachments } from '@/components/attachments';
import { AttachmentType } from '@/types/enums';

export const AnalysisAttachments = ({ transition }: UIViewInjectedProps) => {
  const params = {
    transition,
    apiEntity: 'LotAnalysis',
    paramId: 'analysisId',
    attachmentType: AttachmentType.LotAnalysis,
    closeRoute: 'base-layout.lots.view',
  };

  return <Attachments<cyrian.api.lots.LotAnalysis & { attachments: any[] }> {...params} />;
};
